import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import NumberInput from '../../../components/Input/NumberInput';
import ButtonAction from '../../../components/Button.js/SaveButton';
import Loader from '../../../components/loader/loader';
import TextInput from 'src/components/Input/TextInput';
import { sendRequest, serviceList } from 'src/utils';
import ChessBoard from 'src/components/ChessBoard/ChessBoard';
import ComboBox from 'src/components/Input/ComboBox';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ConfirmFixDeviceModel = ({ visible = false, callBackFunct, setVisible, data, idPermission }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [flagProcess, setFlagProcess] = useState(false);
    const flagRef = React.useRef(false);
    const [quantity, setQuantity] = useState(1);
    const [grindingPrice, setGrindingPrice] = useState(0);
    const isFinishSelectCell = quantity !== null;
    const [isOpen, setIsOpen] = useState(false);
    const isHandledRef = useRef(false);

    useEffect(() => {
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, []);

    useEffect(() => {
        if (visible) {
            setQuantity(data?.qty_change_request);
            isHandledRef.current = false;
        } else {
            clearIntervalCheckStatusCell();
        }
    }, [visible]);

    const handleClick = useCallback(() => {
        if (isHandledRef.current) return;
        clearIntervalCheckStatusCell();
        isHandledRef.current = true;
        setFlagProcess(true);
        const InVal = [data.device_id, parseInt(quantity), parseFloat(grindingPrice), data.id];
        sendRequest(serviceList.actionConfirmRepaired, InVal, actionResult, true, timeOutFunct, 40000);
    }, [data?.cabinet_id, quantity, grindingPrice, data?.id]);

    const actionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            closeCell();
        }
    };
    // region open cell
    const openCell = (data) => {
        setFlagProcess(true);

        let service = serviceList.openCellIOT;
        let inpuVal = [
            data.cabinet_request_cd || data.cabinet_cd,
            data.drawer_lc,
            data.cell_lc.row,
            data.cell_lc.column,
        ];

        if (data?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [
                data.cabinet_request_cd || data.cabinet_cd,
                data.drawer_lc,
                data.cell_lc.row,
                data.cell_lc.column,
            ];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [data.cabinet_request_cd || data.cabinet_cd, data.drawer_lc, data.cell_lc.row, data.column];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunct, 40000, 0);
    };

    const openCellResult = (reqInfoMap, message) => {
        console.log('reqInfoMap', reqInfoMap['input_param']);

        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();
            toast.error('Error: ' + message['proc_message']);
        } else {
            // isGivedevice ? handleActionGiveDevice() : handleActionDevice();
            setFlagProcess(false);
            setIsOpen(true);
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            // setTimeout(() => {
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            // }, 5000);
        }
    };

    // region closeCell
    const closeCell = () => {
        let service = serviceList.closeCellIOT;
        let inpuVal = [data.cabinet_request_cd, data?.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        clearIntervalCheckStatusCell();
        if (data?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [data.cabinet_request_cd, data?.drawer_lc, data.cell_lc.row, data.cell_lc.column];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [data.cabinet_request_cd, data?.drawer_lc, data.cell_lc.row, data.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunct, 40000, 0);
        // console.log('inpuValClose: ', inpuVal);
        // console.log('serviceListClose: ', service);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setIsOpen(false);
            setFlagProcess(false);
            callBackFunct && callBackFunct();
        }
        clearIntervalCheckStatusCell();
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
        checkIntervalCheckStatusCell.current = null;
        checkStatusCellFlag.current = false;
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;

        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            40000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            handleClick();
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        setFlagProcess(false);
    };

    const timeOutFunct = (reqInfo) => {
        setFlagProcess(false);
        setIsOpen(false);
        toast.error(t('error.time_out'));
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('confirm_fix_device')} <br /> {t('name_device')}: {data?.device_cd}_{data?.device_nm}
            </BootstrapDialogTitle>
            <Loader loading={flagProcess} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {/* <Grid item style={{ width: '100%' }} xs={4}>
                        <NumberInput
                            label={t('number_of_damaged')}
                            valueChange={quantity}
                            size="medium"
                            getValue={setQuantity}
                        />
                    </Grid> */}

                    <Grid item style={{ width: '100%' }} xs={12}>
                        <NumberInput
                            label={t('price_fix_device')}
                            valueChange={grindingPrice}
                            size="medium"
                            getValue={setGrindingPrice}
                        />
                    </Grid>

                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                        <ComboBox
                            label={t('choose_drawer')}
                            sizeCbb="medium"
                            displayLabel="label"
                            valueEqual="value"
                            valueSelect={{
                                label: data?.drawer_nm,
                                value: data?.drawer_id,
                            }}
                            disabled={true}
                            getValue={() => {}}
                            selectOption={[
                                {
                                    label: data?.drawer_nm,
                                    value: data?.drawer_id,
                                },
                            ]}
                            required
                        />
                    </Grid>

                    <Typography variant="h5" sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
                        {t('select_old_cell')}
                    </Typography>
                    <ChessBoard
                        rows={data?.row}
                        columns={data?.column}
                        cell_id_request={data?.cell_request_id}
                        activePosition={{
                            row: data?.cell_lc?.row ? data.cell_lc.row : 1,
                            column: data?.cell_lc?.column ? data.cell_lc.column : 1,
                        }}
                        typeCabinet={data?.cabinet_type}
                    />
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                {!isOpen ? (
                    <ButtonAction
                        disabled={!isFinishSelectCell}
                        onClick={() => {
                            openCell(data);
                            // handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('open_cell_input')}
                    />
                ) : (
                    <ButtonAction
                        onClick={() => {
                            handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('confrim_success')}
                    />
                )}
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ConfirmFixDeviceModel;
